export const destroy = (self) => {
  if (self._canvas_el != null) {
    self._container_el?.removeChild(self._canvas_el);
  }
  self._container_el = null;
  self._canvas_el = null;
  self._dummy_g_el = null;
  self._layers_el = null;
  self._art_board_layer_el = null;
  self._target_image_layer_el = null;
  self._stand_leg_layer_el = null;
  self._foreground_layer_el = null;
  self._art_board_rect_el = null;
  self._art_board_filter_el = null;
  self._art_board_filter_drop_shadow_el = null;
  self._art_board_shape_path_el = null;
  self._target_image_dummy_g_el = null;
  self._stand_leg_path_el = null;
  self._view_port = null;
  self._view_box = null;
  self._art_board = null;
  self._stroke_sync = null;
  self._target_image_el = null;
};
